// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"591":"0e7224ef","709":"18080222"}[chunkId] + ".css";
};